// import React from 'react';
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "./axios";
import './App.css';
// import EventView from '../src/img/web_image.png';
import seriti_loader1 from './Images/logo/Seriti Loader.gif';
import seriti_loader from './Images/logo/Seriti BW - system logo.png';

const MaintenanceMode = () => {
    // console.log("rjfjdk");
    const navigate = useNavigate();
    // const [Showmaintancemode, setShowmaintancemode] = useState(null);
    
    useEffect(() => {
      axios.get("get_maintancemode")
          .then((response) => {
              // console.log(response.data.data.checkbox_edit_array);
              if (response.status === 200) {
                 const mode = response.data.data;
                 //console.log(mode[0].maintance_mode);
                if (mode[0].maintance_mode === 0) {
                  if (localStorage.getItem("Token")) {
                      navigate('/home');
                  }else{
                      navigate('/singin');
                  }
                }  
              }
          })
          .catch(() => {
              console.log('error');
          });
  }, []);

  return (
   
    <div style={{background: 'linear-gradient(145deg, rgb(251 208 201 / 20%) 0%, rgb(255 209 253 / 20%) 100%)'}}>
      <div className="row w-100 px-4" >
        <div className="col-sm-12 d-flex align-items-center justify-content-center flex-column" style={{height:"100vh"}}>
          
          <img className="maintenance-ytcr-logo my-2" src={seriti_loader} alt="Seriti"/> <br /> <br />
          
          {/* <img className="maintenance-img my-5" src={EventView} alt="maintenance img" /> */}
          
          <h1 className="maintenance-title text-center">The site is currently under maintenance</h1>
          <img className="maintenance-ytcr-logo my-2" src={seriti_loader1} alt="Seriti" height={100} width={100}/>
          
          <h5 className="maintenance-subtitle text-center my-3">We apologize for any inconvenviences caused.</h5>
        
        </div>
        
      </div>
    </div>
  );
};

export default MaintenanceMode;